import { render } from "./dogImage.vue?vue&type=template&id=133fb406&scoped=true&ts=true"
import script from "./dogImage.vue?vue&type=script&lang=ts"
export * from "./dogImage.vue?vue&type=script&lang=ts"

import "./dogImage.vue?vue&type=style&index=0&id=133fb406&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133fb406"]])

export default __exports__